import EditableField from './EditableField';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';

const LabelValuePair = props => {

  const shouldHightlight = (label, value) => {
    return props.viewMode && !_.isEmpty(value) && !_.isEmpty(props.originalData)
     && !_.isEmpty(props.originalData[label]) && !_.isEqual(props.originalData[label].toString(), value.toString());
  }

  return (
    <>
      <Row className="mr-0 p-0 pt-1" >
        <Col md={5} xs={5} lg={5} sm={5} xl={5} className='text-left'>
          <h6 className={`text-nowrap ${shouldHightlight(props.label, props.value) && "color-red"}`}>{props.label}</h6>
        </Col>
        <Col md={7} xs={7} lg={7} sm={7} xl={7} className="text-right">
          {props.viewMode ? (
            <h6 className={`label-values text-nowrap text-ellipsis text-color-grey ${shouldHightlight(props.label, props.value) && "color-red"}`}>
              {props.value}
            </h6>
          ) : (
            <EditableField
              data={props.data}
              value={props.value}
              handleChange={e => props.handleChange && props.handleChange(e, props.label)}
              label={props.label}
            ></EditableField>
          )}
        </Col>
      </Row>
      <hr className="underLine"></hr>
    </>
  );
};

export default LabelValuePair;
